<template>
  <div class="auditearnest">
    <div class="title">
      公司列表 <span>{{title}}</span>
    </div>
    <div class="main">
      <div class="auditEarnestInfo">{{title}}</div>
      <div class="earnestContent">
        <div class="earnestlist">
          <span>待付公司名称：</span>
          <p>{{data.companyName}}</p>
        </div>
        <div class="earnestlist">
          <span>缴纳金额：</span>
          <p>￥{{data.money}}</p>
        </div>
        <div class="earnestlist">
          <span>开户行名称：</span>
          <p>{{data.bankName}}</p>
        </div>
        <div class="earnestlist">
          <span>开户账号：</span>
          <p>{{data.openAccount}}</p>
        </div>
        <div class="earnestlist">
          <span>开户行支行：</span>
          <p>{{data.openBank}}</p>
        </div>
        <div class="earnestBtn">
          <button class="save"
                  @click="handleApprovedClick">
            <span v-if="id">通过</span>
            <span v-else-if="refundID">确定退款</span>
          </button>
          <button @click="handleRejectedClick"
                  class="cancel">
            不通过
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getEarnest, auditEarnest } from 'apis/index'

export default {
  name: 'auditearnest',
  data () {
    return {
      title: '',
      id: '',
      refundID: '',
      data: {}
    }
  },

  methods: {
    handleApprovedClick () { // 审核通过
      // console.log(this.data)
      if (this.id) { // 审核通过
        let status = 2
        this.audit(status)
        // console.log('审核通过')
      }
      if (this.refundID) { // 退款通过
        let status = 3
        this.audit(status)
        // console.log('退款')
      }
    },
    handleRejectedClick () { // 审核不通过
      let status = 1
      this.audit(status)
    },
    audit (item) {
      auditEarnest({
        logisticsBondId: this.data.logisticsBondId,
        companyId: this.data.companyId,
        status: item
      }).then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          this.$router.push({ path: '/manage/companylist' })
        }
      })
    },
    getData (id) {
      getEarnest({
        companyId: id
      }).then(res => {
        if (res.data.code === 200) {
          // console.log('sss', res)
          if (res.data.desc === '还没有申请保证金') {
            this.$alert('还未缴纳保证金，无法审核', '注意', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push({ path: '/manage/companylist' })
              }
            })
          } else {
            this.data = res.data.data
          }
        }
      })
    }
  },
  mounted () {
    this.id = this.$route.query.id
    // console.log('adafdfdsafasd', this.id)
    if (this.id) {
      this.title = '审核保证金'
      this.getData(this.id)
    }
    this.refundID = this.$route.query.refundID
    // console.log('asdfasdfdasfasdf-----', this.refundID)
    if (this.refundID) {
      this.title = '退款'
      this.getData(this.refundID)
    }
  }
}
</script>
<style lang="stylus">
.auditearnest
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .auditEarnestInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/07/shenhei_con.png') no-repeat center left 15px
    .earnestContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .earnestlist
        margin-top 26px
        width 100%
        height 32px
        span
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
        p
          float left
          line-height 32px
          padding-left 10px
      .earnestBtn
        margin-left 148px
        margin-top 94px
        button
          width 78px
          height 28px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          color #1B88EE
          border-radius 3px
          border 1px solid #CFD5DC
          &:nth-child(1)
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
